module.exports = __webpack_public_path__ + "img/MANCHESTER.d68a5045.webp";